// Third Party
import { map } from "rxjs/operators";
import { ofType } from "redux-observable";

// Project
import { toAddressUpdateStart } from "../../actions/draftToActions";
import { DRAFT_REMOVE_TO_ADDRESSEE } from "../../constants/ActionTypes";

const isAutosaving = true;

/* eslint-disable arrow-body-style */
const removeToAddresseeEpic = action$ => action$.pipe(
  ofType(DRAFT_REMOVE_TO_ADDRESSEE),
  map(action => toAddressUpdateStart(action.mailboxAddress, action.draftIdentity, isAutosaving))
);

export default removeToAddresseeEpic;
